import { FC } from 'react';

import { Badge, Button, ButtonProps } from 'antd';

import NotificationsIcon from 'assets/images/menu/notifications.svg?react';
import { useGetNotificationsCountQuery } from 'entities/Notification/api/api';
import { useCommonSlice } from 'shared/hooks';

interface IMenuIconProps extends ButtonProps {}

export const MenuIcon: FC<IMenuIconProps> = ({ className, ...props }) => {
	const { data } = useGetNotificationsCountQuery(undefined, { pollingInterval: 10000 });
	const { notificationsModalIsOpened } = useCommonSlice();

	return (
		<Badge dot={!!data?.unread_count} offset={[-16, 13]}>
			<Button
				{...props}
				type={notificationsModalIsOpened ? 'primary' : 'text'}
				shape="circle"
				size="small"
				icon={<NotificationsIcon />}
				className={className}
			/>
		</Badge>
	);
};
